// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const UnavailRiskIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  "aria-hidden": "true",
  "data-icon": "UnavailRisk/outline"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.5,
  fill: "currentColor",
  stroke: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M4.667 7.422 8.089 4l3.422 3.422m-6.844 3.911 3.422-3.422 3.422 3.422"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));
export default UnavailRiskIcon;